<template>
    <div v-loading.fullscreen.lock="fullscreenLoading">


        <!--コンテンツ-->
        <main id="renew2_mypage">
            <div class="quickmail_container">
                <div class="renew2_wrapper renew2_flex">
                    <div class="servicelist">
                        <ul class="servicelist__block renew2_pc">
                            <li class="servicelist__item waiting"><a href="/kr/resume/mypage"><img
                                        src="/kr/resume/static/renew2_img/icon_mypagetop.svg" alt="마이페이지"><br>마이페이지</a>
                            </li>
                            <li class="servicelist__item waiting"><a href="/kr/resume/mypage/yagioffer"><img
                                        src="/kr/resume/static/renew2_img/icon_yagioffer.svg" alt="야기오퍼"><br>야기오퍼</a>
                            </li>
                            <li class="servicelist__item onclick"><a href="/kr/resume/mypage/quickmail"><img
                                        src="/kr/resume/static/renew2_img/icon_quickmail.svg" alt="야기택배"><br>야기택배</a>
                            </li>
                            <li class="servicelist__item waiting"><a href="/kr/resume/mypage/quickemail"><img
                                        src="/kr/resume/static/renew2_img/icon_quickemail.svg" alt="야기메일"><br>야기메일</a>
                            </li>
                            <li class="servicelist__item waiting"><a href="/kr/resume/mypage/introduction"><img
                                        src="/kr/resume/static/renew2_img/icon_recommend.svg"
                                        alt="추천·소개서"><br>추천·소개서</a></li>
                        </ul>
                        <div class="renew2_sp">
                            <ul class="servicelist__block renew2_sp_flex">
                                <li class="servicelist__item waiting"><a href="/kr/resume/mypage/yagioffer"><img
                                            src="/kr/resume/static/renew2_img/icon_yagioffer.svg"
                                            alt="야기오퍼"><br>야기오퍼</a></li>
                                <li class="servicelist__item onclick"><a href="/kr/resume/mypage/quickmail"><img
                                            src="/kr/resume/static/renew2_img/icon_quickmail.svg"
                                            alt="야기택배"><br>야기택배</a></li>
                                <li class="servicelist__item waiting"><a href="/kr/resume/mypage/quickemail"><img
                                            src="/kr/resume/static/renew2_img/icon_quickemail.svg"
                                            alt="야기메일"><br>야기메일</a></li>
                                <li class="servicelist__item waiting"><a href="/kr/resume/mypage/introduction"><img
                                            src="/kr/resume/static/renew2_img/icon_recommend.svg"
                                            alt="추천·소개서"><br>추천·소개서</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="mypage_contents">
                        <div class="renew2_flex lead">
                            <h2>야기택배</h2>
                            <a v-if="$site.appFlag != 'b' || true" href="/kr/resume/quickmailhelp" target="_blank"
                                class="">야기택배란?</a>
                        </div>
                        <p>이력서를 출력하면 우편으로 배송하여 드립니다.<br>
                            필요 항목을 작성한뒤 신용카드 결제가 진행됩니다.</p>
                        <div class="quickmail_block">
                            <ul v-if="quickmailList.quickmail_list" class="quickmail_block__list">
                                <li class="renew2_flex quickmail_block__item"
                                    v-for="(item, index) in quickmailList.quickmail_list" :key="index">
                                    <p class="date">{{ item.regist_date }}</p><!--日付-->
                                    <p class="company">{{ item.quickmail_companyname }}</p>
                                    <p class="status"><span class="buy">구입</span>•••<span v-if="item.send_flag == '1'"
                                            class="sent">우편전송완료</span><span v-else class="before">준비중</span></p>


                                    <div v-if="!item.detail_display" class="confirmation_btn"
                                        @click="!item.detail_display ? item.detail_display = true : item.detail_display = false">
                                        <label for="confirmation1" class="confirmation">전송내용</label>
                                    </div>
                                    <div v-else class="confirmation_btn"
                                        @click="!item.detail_display ? item.detail_display = true : item.detail_display = false">
                                        <label for="confirmation1" class="confirmation"><i
                                                class="el-icon-circle-close-outline"></i>닫기</label>
                                    </div>

                                    <div class="dropdown1" v-if="item.detail_display">
                                        <p>送付先企業名：<span>{{ item.quickmail_companyname }}</span></p>
                                        <p>送付先担当者名：<span>{{ item.quickmail_staffname }}</span></p>
                                        <p>企業住所：<span>{{ item.quickmail_post }}
                                                {{ item.quickmail_address1 }}{{ item.quickmail_address2 }}</span></p>
                                        <p>差出人名：<span>{{ item.from_name }}</span></p>
                                        <p>差出人住所：<span>{{ item.from_post }}
                                                {{ item.from_address1 }}{{ item.from_address2 }}</span></p>
                                        <a @click="openQuickmailDetailDialog(index)">전송한 이력서확인</a>
                                    </div>
                                </li>
                            </ul>
                            <p v-else class="not_used">이용내역이 없습니다.</p>
                        </div>
                        <div class="renew2_sp">
                            <a href="/kr/resume/mypage" class="servicelist__mypage"><img
                                    src="/kr/resume/static/renew2_img/icon_mypagetop.svg" alt="마이페이지">마이페이지로</a>
                        </div>
                    </div>
                </div>
            </div>
        </main>

        <modal name="qmail-detail-dialog" :adaptive="true" :scrollable="true" height="auto"
            @opened="setQmailPreviewScale(); previewQmailLoading = false">
            <div class="v--modal-close-top">
                <el-button @click="$modal.hide('qmail-detail-dialog')" icon="el-icon-circle-close-outline"
                    style="font-size: 2rem;" type="text"></el-button>
            </div>

            <div class="backup-preview-dialog">
                <el-tabs v-model="activeQmailPreviewTab" class="backup-tabs" :stretch="true"
                    @tab-click="setQmailPreviewScale(); previewQmailLoading = false">
                    <el-tab-pane label="송장" name="format_letter" :lazy="true" :style="qmailViewerCssLetter">
                        <div v-html="qmail_letter_html" ref="letter_pane" :style="scaleQmailStyle"></div>
                    </el-tab-pane>
                    <el-tab-pane label="이력서" name="format_rirekisho" :lazy="true" :style="qmailViewerCssRirekisho">
                        <div v-html="qmail_rirekisho_html" ref="rirekisho_pane" :style="scaleQmailStyle"></div>
                    </el-tab-pane>
                    <el-tab-pane v-if="selectedQuickmailData.keirekisho_flag == '1'" label="경력기술서"
                        name="format_shokumukeirekisho" :lazy="true" :style="qmailViewerCssShokurekisho">
                        <div v-html="qmail_shokumukeirekisho_html" ref="shokumukeirekisho_pane"
                            :style="scaleQmailStyle"></div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </modal>


    </div>
</template>

<style lang="css" src="@/assets/css/renew2_mypage.css"></style>

<style scoped></style>



<script>
import {
    TabPane,
    Tabs,
    MessageBox
} from 'element-ui'

import LoginForms from '@/components/RenewLoginForms'
import firebase from 'firebase/app'

const RECENT_EDIT_SAVE_KEY = 'recentEdit'
const DOC_PAPER_HEIGHT_PX = 794
export default {
    components: {
        'el-tabs': Tabs,
        'el-tab-pane': TabPane,
        'login-forms': LoginForms
    },
    data: function () {
        return {
            fullscreenLoading: true,
            selectedQuickmailData: {},
            quickmailList: [],
            qmail_rirekisho_html: '',
            qmail_shokumukeirekisho_html: '',
            qmail_letter_html: '',
            backupListLoaded: {
                auto: false,
                user: false
            },
            saved: false,
            recomm_code: '',
            saveLabel: '',
            backupDataToConfirm: null,
            previewScale: 1,
            previewQmailScale: 1,
            backupDataViewerCssRirekisho: {},
            backupDataViewerCssShokurekisho: {},
            qmailViewerCssRirekisho: {},
            qmailViewerCssShokurekisho: {},
            qmailViewerCssLetter: {},
            deleteBackupPopoverVisible: false,
            previewLoading: false,
            rirekisho_height: 110,
            keirekisho_height: 110,
            letter_height: 110,
            previewQmailLoading: false,
            activeTabName: 'user',
            activePreviewTab: 'format_rirekisho',
            activeQmailPreviewTab: 'format_rirekisho'
        }
    },
    computed: {
        getMode: function () {
            return process.env.VUE_APP_MODE
        },
        scaleQmailStyle: function () {
            const _style = {
                'transform': 'scale(' + this.previewQmailScale + ')',
                'transform-origin': 'top left',
                'height': (this.rirekisho_height * this.previewQmailScale)
            }
            return _style
        }
    },
    methods: {
        setQmailPreviewScale: function () {
            this.$nextTick(function () {
                if (this.activeQmailPreviewTab === 'format_rirekisho') {
                    if (this.$refs.rirekisho_pane.clientWidth === 0) {
                    } else {
                        const clientWidth = this.$refs.rirekisho_pane.clientWidth
                        this.previewQmailScale = clientWidth / Math.max(clientWidth, DOC_PAPER_HEIGHT_PX)
                    }
                } else if (this.activeQmailPreviewTab === 'format_shokumukeirekisho') {
                    if (this.$refs.shokumukeirekisho_pane.clientWidth === 0) {
                    } else {
                        const clientWidth = this.$refs.shokumukeirekisho_pane.clientWidth
                        this.previewQmailScale = clientWidth / Math.max(clientWidth, DOC_PAPER_HEIGHT_PX)
                    }
                } else if (this.activeQmailPreviewTab === 'format_letter') {
                    if (this.$refs.letter_pane.clientWidth === 0) {
                    } else {
                        const clientWidth = this.$refs.letter_pane.clientWidth
                        this.previewQmailScale = clientWidth / Math.max(clientWidth, DOC_PAPER_HEIGHT_PX)
                    }
                }
                this.$nextTick(function () {
                    this.setQmailPreviewHeight()
                })
            })
        },
        setQmailPreviewHeight: function () {
            if (this.activeQmailPreviewTab === 'format_rirekisho') {
                const height = this.$refs.rirekisho_pane.getBoundingClientRect().height
                // const height = 10
                if (!height) {
                    return
                }

                this.qmailViewerCssRirekisho = {
                    height: height + 30 + 'px'
                }
                this.rirekisho_height = height + 30
            } else if (this.activeQmailPreviewTab === 'format_shokumukeirekisho') {
                const height = this.$refs.shokumukeirekisho_pane.getBoundingClientRect().height
                // const height = 10
                if (!height) {
                    return
                }
                this.qmailViewerCssShokurekisho = {
                    height: height + 30 + 'px'
                }
                this.keirekisho_height = height + 30
            } else if (this.activeQmailPreviewTab === 'format_letter') {
                const height = this.$refs.letter_pane.getBoundingClientRect().height
                // const height = 10
                if (!height) {
                    return
                }
                this.qmailViewerCssLetter = {
                    height: height + 30 + 'px'
                }
                this.letter_height = height + 30
            }
        },
        openQuickmailDetailDialog: function (idx) {
            this.selectedQuickmailData = this.quickmailList.quickmail_list[idx]
            this.$modal.show('qmail-detail-dialog')
            console.error(this.selectedQuickmailData)
            this.qmail_rirekisho_html = this.selectedQuickmailData.rirekisho_html
            this.qmail_shokumukeirekisho_html = this.selectedQuickmailData.keirekisho_html
            this.qmail_letter_html = this.selectedQuickmailData.letter_html
            this.qmailViewerCssRirekisho = {}
            this.qmailViewerCssShokurekisho = {}
            this.qmailViewerCssLetter = {}
        }
    },
    created: function () {
        const app = this
        // console.log(this.$route.query.mynavi)
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                console.log('logined')
                const formData = new FormData()
                formData.append('access_id', '')
                formData.append('uuid', app.$firebase.user.uid)
                formData.append('device_flg', app.$deviceLib.isMobileDevice ? 'SP' : 'PC')
                formData.append('version', '2')
                formData.append('reqflg', '2')
                this.$axios
                    .post(this.$varuna.endPoints.getQuickmailList, formData, { timeout: 60000 })
                    .then(function (response) {
                        app.quickmailList = response.data
                    })
                this.fullscreenLoading = false

            } else {
                this.$router.push('/login')
            }
        })
    },
    beforeMount: function () {
    },
    destroyed: function () {
    }
}
</script>
